import { render, staticRenderFns } from "./ProjChange.vue?vue&type=template&id=469e5836"
import script from "./ProjChange.vue?vue&type=script&lang=js"
export * from "./ProjChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports